import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import TableComponent from "../../Common/TableComponent/tableComponent";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "../../Common/Loader/loader";
import { withTranslation } from "react-i18next";
import * as XLSX from "xlsx"; // Import XLSX library for Excel operations````````````````````````````````````
import {
  GetAllAssociatedTransferStations,
  createTransferStationInchargeMaster,
  getAllTransferStationInchargeMaster,
  getAllTransferStationMaster,
  updateTransferStationInchargeMaster,
} from "../../Apis/transferStationApi";
import Select from "react-select";
import ExcelJS from "exceljs";
const LoadingEquipmentDriverDetails = ({ t }) => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const [isEditMode, setIsEditMode] = useState(false);
  const [lgShow, setLgShow] = useState(false);
  const headers = [
    "transferstationIncharge",
    "associatedTransferstation",
    "emailId",
    "isSupervisor",
    "mobileNumber",
    "status",
    "actions",
  ];
  const [transferStationInchargeData, setTransferStationInchargeData] =
    useState([]);
  const [associatedTransferStationData, setAssociatedTransferStationData] =
    useState([]);
  const [editTransferStationInchargeData, setEditTransferStationInchargeData] =
    useState("");
  const [formInput, setFormInput] = useState({
    transferStationInchargeName: "",
    associatedTransferStationIds: "",
    emailId: "",
    isSupervisor: true,
    mobileNumber: "",
    isActive: true,
    transferStationInchargeId: "",
  });
  const [editTransferStationInchargeId, setEditTransferStationInchargeId] =
    useState(null);
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);
  const [selectedTransferStationIncharge, setSelectedTransferStationIncharge] =
    useState(null);
  const resetRef = useRef(null);
  const [isInputValid, setIsInputValid] = useState(true);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const resetFields = (reset) => {
    setFormInput({
      transferStationInchargeName: "",
      associatedTransferStationIds: "",
      emailId: "",
      isSupervisor: "",
      mobileNumber: "",
      isActive: "",
    });
    resetRef.current();
  };

  useEffect(() => {
    resetRef.current = reset;
  }, [reset]);

  const handleClose = () => {
    resetFields();
    setLgShow(false);
    setIsEditMode(false);
    setSelectedTransferStationIncharge(null);
    setFormSubmitted(false);
  };

  const handleEditTransferStationIncharge = async (
    selectedTransferStationInchargeData
  ) => {
    setEditTransferStationInchargeData(selectedTransferStationInchargeData);
    setEditTransferStationInchargeId(selectedTransferStationInchargeData.id);
    setSelectedTransferStationIncharge(selectedTransferStationInchargeData);
    setLgShow(true);
    setIsOptionsLoading(true);
    setTimeout(() => {
      setIsOptionsLoading(false);
    }, 1000);

    setFormInput({
      ...formInput,

      transferStationInchargeName:
        selectedTransferStationInchargeData.transferStationInchargeName,
      associatedTransferStationIds:
        selectedTransferStationInchargeData.associatedTransferStationIds,
      emailId: selectedTransferStationInchargeData.emailId,
      isSupervisor: selectedTransferStationInchargeData.isSupervisor,
      mobileNumber: selectedTransferStationInchargeData.mobileNumber,
      isActive: selectedTransferStationInchargeData.isActive,
      transferStationInchargeId:
        selectedTransferStationInchargeData.transferStationInchargeId,
    });

    reset();
  };

  // const fetchTransferStationIncharge = async () => {
  //   try {
  //     const response = await getAllTransferStationInchargeMaster();
  //     // console.log(response, 'fetch response from first')
  //     const transferStationInchargeDataResponse = response.map(transferStation => ({
  //       ...transferStation,
  //       status: transferStation.isActive ? "Active" : "InActive",
  //     }));

  //     // Sort the data based on the isActive field
  //     const sortedInchargeData = transferStationInchargeDataResponse.sort((a, b) => {
  //       if (a.isActive === b.isActive) {
  //         return 0;
  //       }
  //       return a.isActive ? -1 : 1;
  //     });
  //     setTransferStationInchargeData(sortedInchargeData);

  //     console.error("Error fetching Deployment TransferStationIncharge data:", error);
  //   }
  // };

  const fetchTransferStationIncharge = async () => {
    try {
      const allTransferStations = await getAllTransferStationMaster();
      const transferStationInchargeDataResponse =
        await getAllTransferStationInchargeMaster();

      const sortedInchargeData = transferStationInchargeDataResponse
        .map((transferStation) => {
          const associatedTransferStation = allTransferStations.find(
            (station) =>
              transferStation.associatedTransferStationIds.includes(
                station.transferStationId
              )
          );

          return {
            ...transferStation,
            associatedTransferstation: associatedTransferStation
              ? associatedTransferStation.transferStationName
              : "",
              transferstationIncharge: transferStation
              ? transferStation.transferStationInchargeName
              : "",
            status: transferStation.isActive ? "Active" : "InActive",
          };
        })
        .sort((a, b) => {
          if (a.isActive === b.isActive) {
            return 0;
          }
          return a.isActive ? -1 : 1;
        });

      setTransferStationInchargeData(sortedInchargeData);
      setIsOptionsLoading(false);
    } catch (error) {
      console.error(
        "Error fetching Deployment TransferStationIncharge data:",
        error
      );
    }
  };

  const fetchAssociatedTransferStation = async () => {
    try {
      const response = await GetAllAssociatedTransferStations();
      setAssociatedTransferStationData(response);
      // console.log(response, 'fetchAssociatedTransferStation')
      setIsOptionsLoading(false);
    } catch (error) {
      console.error(
        "Error fetching Deployment TransferStationIncharge data:",
        error
      );
    }
  };

  const addNewTransferStationIncharge = async (data) => {
    try {
      setFormSubmitted(true);
      const firstDigit = formInput.mobileNumber.charAt(0);
  if (!["6", "7", "8", "9"].includes(firstDigit)) {
    // toast.error("Mobile number should start with 6, 7, 8, or 9", {
    //   position: "top-right",
    //   autoClose: 5000,
    //   hideProgressBar: false,
    // });
    return; // Prevent form submission
  }
      setIsOptionsLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 1000));

      if (
        !formInput.transferStationInchargeName ||
        !formInput.associatedTransferStationIds.length ||
        !formInput.emailId ||
        !formInput.mobileNumber
      ) {
        // Display toast message indicating the required field
        // toast.error("Please fill out all required fields", {
        //   position: "top-right",
        //   autoClose: 5000,
        //   hideProgressBar: false,
        // });
        // Stop further execution
        return;
      }

      // const transferStationInchargeName = data.transferStationInchargeName || "";
      // const associatedTransferStationIds = data.associatedTransferStationIds || "";
      // const emailId = data.emailId || "";
      // const transferStationInchargeId = data.transferStationInchargeId || "";
      // const mobileNumber = data.mobileNumber || "";
      // const isSupervisor = data.isSupervisor || "";
      // const isActive = data.isActive || '';
      const {
        transferStationInchargeName,
        associatedTransferStationIds,
        emailId,
        transferStationInchargeId,
        mobileNumber,
        isSupervisor,
        isActive,
      } = formInput;
      const requestData = {
        transferStationInchargeName,
        associatedTransferStationIds: Array.isArray(
          associatedTransferStationIds
        )
          ? associatedTransferStationIds // If it's already an array, use it as is
          : associatedTransferStationIds.split(","), // Otherwise, convert it to an array
        emailId,
        transferStationInchargeId,
        mobileNumber,
        isSupervisor,
        isActive,
      };
      if (selectedTransferStationIncharge) {
        const res = await updateTransferStationInchargeMaster(
          selectedTransferStationIncharge.id,
          requestData
        );
        const successMessage = "TransferStationIncharge Updated Successfully!";
        toast.success(successMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        fetchTransferStationIncharge();
        reset();
        handleClose();
      } else {
        const res = await createTransferStationInchargeMaster(requestData);
        // console.log(res, 'res from add')
        const successMessage =
          "New TransferStationIncharge Added Successfully!";
        toast.success(successMessage, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        fetchTransferStationIncharge();
        reset();
        handleClose();
      }
    } catch (error) {
      console.log(error.response, "error.response.status");
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else if (status === 409) {
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else if (status === 404) {
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else {
          toast.error("An error occurred. Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      }
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const handleKeyDown = (event, callback) => {
    if (event.key === "Enter" && event.shiftKey === false) {
      event.preventDefault();
      callback(addNewTransferStationIncharge);
    }
  };

  useEffect(() => {
    fetchTransferStationIncharge();
    fetchAssociatedTransferStation();
  }, []);

  // const handleStatusChange = (e) => {
  //   const statusValue = e.target.id === "true" ? true : false;
  //   setFormInput((prevData) => ({
  //     ...prevData,
  //     status: statusValue,
  //   }));
  // };

  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prevData) => ({
      ...prevData,
      [name]: value === "true" ? true : false,
    }));
  };

  const handleShow = () => {
    setLgShow(true);
    setIsOptionsLoading(true);
    setFormInput({
      transferStationInchargeName: "",
      associatedTransferStationIds: "",
      emailId: "",
      isSupervisor: true,
      mobileNumber: "",
      isActive: true,
    });
    setTimeout(() => {
      setIsOptionsLoading(false);
    }, 1000);
  };

  const handleSupervisorChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prevData) => ({
      ...prevData,
      [name]: value === "true" ? true : false,
    }));
  };

  const handleAssociateChange = (selectedOptions) => {
    // If selectedOptions is an array, it means multiple options are selected
    // Otherwise, it's a single option
    const selectedValues = Array.isArray(selectedOptions)
      ? selectedOptions.map((option) => option.value)
      : selectedOptions
      ? selectedOptions.value
      : null;

    // Update the form input with the selected values
    setFormInput((prevState) => ({
      ...prevState,
      associatedTransferStationIds: selectedValues,
      // Automatically switch to true if more than one transfer station is selected
      isSupervisor:
        selectedValues && selectedValues.length > 1
          ? true
          : prevState.isSupervisor,
    }));
    if (selectedValues && selectedValues.length === 0 && formSubmitted) {
      setIsInputValid(false); // Set input validity to false if no options selected after form submission
    } else {
      setIsInputValid(true); // Set input validity to true if options are selected or form not submitted
    }
  };


  const options2 = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date()
    .toLocaleString("en-GB", options2)
    .replace(/\//g, "/")}`;
    
  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Transfer Station Incharge Report Generated on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Transfer Station Incharge");

    // Define styles
    const boldFont = { bold: true };

    
    worksheet.addRow(["", "",downloadDateTime, "", ""]);
    worksheet.mergeCells(1, 3, 1, 6); // Merge cells for downloadDateTime
    for (let col = 3; col <= 6; col++) {
      worksheet.getCell(1, col).font = boldFont; // Set styles individually
      worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    worksheet.addRow(["", "","Transfer Staion Incharge", "", ""]);
    worksheet.mergeCells(2, 3, 2, 6); // Merge cells for cumulativeHeadingReport
    for (let col = 3; col <= 6; col++) {
      worksheet.getCell(2, col).font = boldFont; // Set styles individually
      worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    }

    // worksheet.addRow(["", "", "", "", downloadDateTime, "", "", "", ""]);
    // worksheet.mergeCells(2, 5, 2, 8); // Merge cells for downloadDateTime
    // for (let col = 5; col <= 8; col++) {
    //   worksheet.getCell(2, col).font = boldFont; // Set styles individually
    //   worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
    // }

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.no",
      "TransferStation Incharge",
      // "Associate TransferStation",
      "EmailId",
      "Is Supervisor",
      "Mobile",
      "Status"
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left", color: "#fff" }; // Center align the cell content
      if (colNumber >= 1 && colNumber <= 11) {
        // Apply background color and set text color
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
          bgColor: { argb: "FFFFFFFF" }, // White text color
        };
      }
    });

    // Add data rows
    transferStationInchargeData.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
        item.transferStationInchargeName,
        // item.associatedTransferStationIds,
          item.emailId,
         item.isSupervisor,
          item.mobileNumber,
          item.status,
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 11) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "left" };
          }
        });
    });

    // Add total row with bold font

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
      { width: 20 },
      { width: 15 },
      { width: 15 },
     
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Routes.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };


  const options = associatedTransferStationData.map((station) => ({
    value: station.transferStationId,
    label: station.transferStationName,
  }));
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let sanitizedValue = value; // Initialize sanitized value with the input value

    if (name === "mobileNumber") {
      // Remove any non-numeric characters
      sanitizedValue = value.replace(/\D/g, '');
      sanitizedValue = sanitizedValue.slice(0, 10);
    }
    // Update the state based on the field name
    setFormInput((prevData) => ({ ...prevData, [name]: sanitizedValue }));

    if (name === "mobileNumber") {
      const firstDigit = sanitizedValue.charAt(0);
      if (!["6", "7", "8", "9"].includes(firstDigit)) {
        // Show error message or handle invalid format
        // For now, I'm just logging an error message
        console.error("Mobile number must start with 6, 7, 8, or 9");
      
    }
  };
}
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="flex_end_middle mb-3">
                <button className="button-container" onClick={handleShow}>
                  <i className="fa-solid fa-plus me-1 icon-container"></i>
                  {t("Add Transfer Station incharge")}
                </button>
             
                <button className="btn btn-excel" onClick={downloadAsExcel}
                >
                   <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                </button>
              </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <div className="top-header">
                    <span>{t("Transfer Station incharge")}</span>
                  </div>
                  <TableComponent
                    DataFetchURL={transferStationInchargeData}
                    headers={headers}
                    filterFunction={(data) =>
                      data.filter(
                        (item) => item.status === 1 || item.status === 0
                      )
                    }
                    editData={handleEditTransferStationIncharge}
                    editTransferStationInchargeData={
                      editTransferStationInchargeData
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      {isOptionsLoading && <Loader />}
      <Modal
        size="lg"
        show={lgShow} 
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {selectedTransferStationIncharge ? "Update TransferStation" : "Add TransferStation "}
          </Modal.Title>
          <i
            class="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form
            onSubmit={handleSubmit(addNewTransferStationIncharge)}
            onKeyDown={(e) => {
              handleKeyDown(e, handleSubmit);
            }}
          >
            <div className="row">
              {/* {selectedTransferStationIncharge ? ( */}
              <div className="col-md-4 " style={{ display: "none" }}>
                <div className="form-group">
                  <label className="form-label">
                    Transfer Station incharge Id
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="transferStationInchargeId"
                    {...register("transferStationInchargeId")}
                    value={formInput.transferStationInchargeId}
                    readOnly
                    onChange={(e) =>
                      setFormInput({
                        ...formInput,
                        transferStationInchargeId: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              {/* ) : (
                ""
              )} */}
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Transfer Station incharge Name
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Incharge Name"
                    className={`form-control ${
                      formInput.transferStationInchargeName || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    name="transferStationInchargeName"
                    {...register("transferStationInchargeName")}
                    value={formInput.transferStationInchargeName}
                    onChange={(e) =>
                      setFormInput({
                        ...formInput,
                        transferStationInchargeName: e.target.value,
                      })
                    }
                  />
                  {!formInput.transferStationInchargeName && formSubmitted && (
                    <div className="required-message">
                      Transfer Station incharge Name is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
  <div className="form-group">
    <label className="form-label">
      Associated Transfer Station{" "}
      <span style={{ color: "#EC1117" }}> *</span>
    </label>
    <Select
      className={`${(!formInput.associatedTransferStationIds.length && formSubmitted) ? "input-error" : ""}`}
      id="associatedTransferStationIds"
      name="associatedTransferStationIds"
      value={options.filter((option) => formInput.associatedTransferStationIds.includes(option.value))}
      onChange={handleAssociateChange}
      isMulti
      options={options}
    />
    {formSubmitted && !formInput.associatedTransferStationIds.length && (
      <div className="required-message">
        Associated Transfer Station Id is Required
      </div>
    )}
  </div>
</div>

              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Email Id<span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Email ID"
                    className={`form-control ${
                      formInput.emailId || !formSubmitted ? "" : "input-error"
                    }`}
                    name="emailId"
                    {...register("emailId")}
                    value={formInput.emailId}
                    onChange={(e) =>
                      setFormInput({
                        ...formInput,
                        emailId: e.target.value,
                      })
                    }
                  />
                  {!formInput.emailId && formSubmitted && (
                    <div className="required-message">Email Id is Required</div>
                  )}
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="form-group">
                  <label className="form-label">
                    Mobile Number<span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                  //  type="number"
                    placeholder="Enter Mobile Number"
                    className={`form-control ${
                      formInput.mobileNumber || !formSubmitted
                        ? ""
                        : "input-error"
                    }`}
                    name="mobileNumber"
                    {...register("mobileNumber")}
                    value={formInput.mobileNumber}
                    onChange={handleInputChange}
                    pattern="[0-9]{10}" // Specify the pattern for 10 digits
                    title="Mobile number must be exactly 10 digits long."
                  />
                  {formInput.mobileNumber.length !== 10 && formSubmitted && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      Mobile number must be exactly 10 digits long.
                    </span>
                  )}
                  {/* {!formInput.mobileNumber && formSubmitted && (
                    <div className="required-message">
                      Mobile Number is Required
                    </div>
                  )} */}
                </div>
              </div>
              <div className="col-md-4"></div>
              <div className="col-md-4"></div>
              <div className="col-md-4 mt-2">
                <label className="form-label">
                  Is Supervisor<span style={{ color: "#EC1117" }}> *</span>
                </label>
                <div className="form-group" style={{ display: "flex" }}>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isSupervisor"
                      id="supervisorActiveRadio"
                      {...register("isSupervisor")}
                      value="true"
                      checked={formInput.isSupervisor === true}
                      onChange={handleSupervisorChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="supervisorActiveRadio"
                    >
                      True
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "60px" }}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isSupervisor"
                      id="supervisorInactiveRadio"
                      {...register("isSupervisor")}
                      value="false"
                      checked={formInput.isSupervisor === false}
                      onChange={handleSupervisorChange}
                      disabled={
                        formInput.associatedTransferStationIds &&
                        formInput.associatedTransferStationIds.length > 1
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="supervisorInactiveRadio"
                    >
                      False
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-md-4"></div>
              <div className="col-md-4"></div>
              {/* {selectedContainer ? ( */}
              <div className="col-md-4 mt-2">
                <label className="form-label">
                  Status <span style={{ color: "#EC1117" }}> *</span>
                </label>
                <div className="form-group" style={{ display: "flex" }}>
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="activeRadio"
                      {...register("isActive")}
                      value="true"
                      checked={formInput.isActive === true}
                      // onChange={() =>
                      //   setFormInput({ ...formInput, isActive: "true" })
                      // }
                      onChange={handleStatusChange}
                    />
                    <label className="form-check-label" htmlFor="activeRadio">
                      Active
                    </label>
                  </div>
                  <div className="form-check" style={{ marginLeft: "60px" }}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="isActive"
                      id="inactiveRadio"
                      {...register("isActive")}
                      value="false"
                      checked={formInput.isActive === false}
                      // onChange={() =>
                      //   setFormInput({ ...formInput, isActive: "false" })
                      // }
                      onChange={handleStatusChange}
                    />
                    <label className="form-check-label" htmlFor="inactiveRadio">
                      Inactive
                    </label>
                  </div>
                </div>
              </div>

              {/* ) : (
                ""
              )} */}
            </div>
            <div className="modal-footer d-flex justify-content-center">
              <button type="submit" className="deployment-button">
                <i class="fa-solid fa-check done-container"></i>
                {selectedTransferStationIncharge ? t("Update") : t("Save")}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(LoadingEquipmentDriverDetails);
